module.exports = __webpack_public_path__ + "account/img/269.59f30d56.png";